// extracted by css-extract-rspack-plugin
export default {"divider":"divider-module__divider___G5_Zk"};